import React, { useState } from 'react';
import { Button, Modal, TextField, Box } from '@mui/material';

export interface SoftPOSAuthorizationModalProps {
    open: boolean;
    handleClose: () => void;
    handleSubmit: (data: { terminalId: string; merchantId: string }) => void;
    onlyInfo?: boolean;
    detail: any;
}

export const SoftPOSAuthorizationModal: React.FC<SoftPOSAuthorizationModalProps> = ({ open, handleClose, handleSubmit, onlyInfo, detail }) => {
    const [terminalId, setTerminalId] = useState<string>('');
    const [merchantId, setMerchantId] = useState<string>('');

    const handleTerminalIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTerminalId(event.target.value);
    };

    const handleMerchantIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMerchantId(event.target.value);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleSubmit({ terminalId, merchantId });
        setTerminalId('');
        setMerchantId('');
    };

    const handleModalClose = () => {
        setTerminalId('');
        setMerchantId('');
        handleClose();
    }

    return (
        <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            style={{ backdropFilter: "blur(15px)" }}
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'white',
                borderRadius: '8px',
                p: 4,
                outline: 'none',
            }}>
                <h3 id="modal-title">İşyerine ait Terminal ID ve Merchant ID bilgilerini giriniz!</h3>
                <form onSubmit={handleFormSubmit}>
                    <TextField
                        label="Terminal ID"
                        variant="outlined"
                        value={onlyInfo ? detail.terminalId : terminalId}
                        onChange={handleTerminalIdChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Merchant ID"
                        variant="outlined"
                        value={onlyInfo ? detail.merchantId : merchantId}
                        onChange={handleMerchantIdChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    {!onlyInfo && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button type="submit" variant="outlined" color="error" onClick={handleClose} sx={{ marginRight: '10px' }}>
                                Vazgeç
                            </Button>
                            <Button type="submit" variant="contained" color="primary">
                                Gönder
                            </Button>
                        </Box>
                    )}
                </form>
            </Box>
        </Modal>
    );
};